"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var FooterComponent = /*#__PURE__*/function () {
  function FooterComponent(header, footer, content) {
    _classCallCheck(this, FooterComponent);

    this._header = header;
    this._footer = footer;
    this._content = content;
    this.init();
  }

  _createClass(FooterComponent, [{
    key: "init",
    value: function init() {
      var _this = this; // init


      new ResizeSensor(_this._content, function (e) {
        _this.updateFooter();
      });

      _this.updateFooter();
    }
  }, {
    key: "updateFooter",
    value: function updateFooter() {
      var _this = this;

      var windowHeight = $(window).outerHeight(true);
      var mainHeight = $(_this._content).outerHeight(true);
      var headerHeight = $(_this._header).outerHeight(true);
      var footerHeight = $(_this._footer).outerHeight(true);

      if (mainHeight + headerHeight + footerHeight + 100 > windowHeight) {
        $(_this._footer).removeClass('fixed');
      } else {
        $(_this._footer).addClass('fixed');
      }
    }
  }]);

  return FooterComponent;
}();